/**
 * `levelIndex` is the level's position in a best-to-worst ordering: index 0 is the best
 * level, `totalLevels - 1` the worst.
 */
interface FilledProficiencyBarsArgs {
    levelIndex: number;
    totalLevels: number;
}

export const isValidProficiencyLevelIndex = ({
    levelIndex,
    totalLevels,
}: FilledProficiencyBarsArgs): boolean =>
    totalLevels > 0 && levelIndex >= 0 && levelIndex < totalLevels;

export const getFilledProficiencyBarsCount = ({
    levelIndex,
    totalLevels,
}: FilledProficiencyBarsArgs): number => {
    if (!isValidProficiencyLevelIndex({ levelIndex, totalLevels })) {
        return 0;
    }

    return totalLevels - levelIndex;
};
